import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarRef, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { ErrorAlertComponent } from '../error-alert/error-alert.component';
import { ErrorNotificationService } from '../error-notification.service';

@Component({
  selector: 'error-pop-up',
  templateUrl: './error-pop-up.component.html',
  styleUrls: ['./error-pop-up.component.scss']
})
export class ErrorPopUpComponent implements OnInit, OnDestroy {

  public errorMessage: string = "";
  public shouldShow: boolean = false;
  public subscription: Subscription;
  public horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  public verticalPosition: MatSnackBarVerticalPosition = 'top';
  public snackBarReference: MatSnackBarRef<ErrorAlertComponent> = null;


  constructor(private errorNotificationService: ErrorNotificationService,
              public dialog: MatDialog,
              private snackBar: MatSnackBar,
              public zoneRef: NgZone) { }
  
  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
      this.snackBarReference = null;
    }
  }

  ngOnInit(): void {
    this.subscription = this.errorNotificationService.notification.subscribe({
      next: (notification) => {
        this.errorMessage = notification;
        this.shouldShow = true;

        if(this.errorMessage) {

          const snackBarData = {
            message: this.errorMessage,
            shouldShowCloseButton: true
          };

          if(!this.snackBarReference) {
            this.zoneRef.run(() => {
              this.snackBarReference = this.snackBar.openFromComponent(ErrorAlertComponent, {
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
                panelClass: 'snackbar-error',
                data: snackBarData
              });
  
              this.snackBarReference.afterDismissed().subscribe(() => {
                this.snackBarReference = null;
              });
            });
          }
        }
      }
    })
  }
}
